import { notifications } from "@mantine/notifications";
import axios from "axios";
import Cookies from "js-cookie";

const instance = axios.create({
  baseURL: process.env.REACT_APP_HOST,
  timeout: 50000,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `${Cookies.get("token")}`;
    return config;
  },
  (error) => {
    return Promise.resolve(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return Promise.resolve({
      ...response?.data,
      status: response.status,
    });
  },
  (error) => {
    const { status, response } = error;
    if (status == 400 || status == 500 || error.code == "ERR_NETWORK") {
      notifications.show({
        title: `Error`,
        message: response?.data?.message || "unkow error",
        position: "top-center",
      });
      return Promise.resolve(error);
    }
    if (status == 401) {
      Cookies.remove("token");
      Cookies.remove("monitor_key");
      window.location.href = "/app/login";
    }
  }
);

export { instance as axios };
